module.exports = __webpack_public_path__ + "assets/Tangent1Detailed.d9019ee701e5626fd6a49abcb3bd57b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Tangent1Detailed.png
// module id = 583
// module chunks = 0